import React from "react";
import { Typography } from "@mui/material";

const EmptyMandatoryAudienceChip: React.FunctionComponent = () => {
    return (
        <div>
            <i>Select at least 1 audience</i>

            <Typography display={"inline"} className="red-text">
                *
            </Typography>
        </div>
    );
};

export default EmptyMandatoryAudienceChip;